module.exports = __webpack_public_path__ + "static/media/infocarro-alpha.ca039f0a.png";